import { useState, useEffect, useRef  } from 'react';
import { useParams } from "react-router-dom";
import axios from 'axios';


import { CcTitle } from '../commonComponents/styledTexts';
import { Icon as Iconify } from '@iconify/react';

import ReportSnippetInfo from './snippetInfo';
import { ReportBar } from './reportBar';
import dayjs from 'dayjs';

import {TimelineEditor} from '../workflows/timedImagesWorkflow'


export default function SnippetTimedImagesReport() {
    const [showLoader, setShowLoader] = useState(false)
    const [snippetInfo, setSnippetInfo] = useState(undefined)
    const [snippetTimedImagesStats, setSnippetTimedImagesStats] = useState(undefined)
    const [timedImagesSettings, setTimedImagesSettings] = useState({})
    const [totalOpens, setTotalOpens] = useState(undefined)
    const [totalClicks, setTotalClicks] = useState(undefined)
    const [topViewsInfo, setTopViewsInfo] = useState({})

  let params = useParams();
      
  useEffect(() => {
      //console.log(params)
    if (params.snippetId !== undefined) {
        setSnippetTimedImagesStats(undefined)
        setSnippetInfo(undefined)
        setTotalOpens(undefined)
        setTotalClicks(undefined)
        getTimedImagesStats(params.snippetId)
        getSnippetInfo(params.snippetId)
    }
  }, [params])

  useEffect(() => {
    if (snippetTimedImagesStats == null || timedImagesSettings == null) return;
    getPrettyTimeRangeForAsset();


  }, [topViewsInfo, timedImagesSettings])

  const getTimedImagesStats = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Stats/element/timedImages/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;

      //console.log(data)
      setSnippetTimedImagesStats(data)
      const [tOpens, tClicks] = getTotals(data)
      setTotalOpens(tOpens)
      setTotalClicks(tClicks)

      const newTopViews = getTopViews(data)
      //getPrettyTimeRangeForAsset(newTopViews.assetId, timedImagesSettings.dates)
      setTopViewsInfo(newTopViews)

    } catch (error) {
      //console.log(error);
    }
  }

  const getSnippetInfo = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;

      setSnippetInfo(data)

      const snippetSettings = JSON.parse(data.snippetSettings)
      //console.log(snippetSettings)
      setTimedImagesSettings(snippetSettings)
  


    } catch (error) {
      //console.log(error);
    }
  }

  const getTotals = (stats) => {
    let totalOpens = 0;
    let totalClicks = 0;

    stats.forEach(s => {
      totalOpens += s.totalOpens
      totalClicks += s.totalClicks
    })
    return [totalOpens, totalClicks]

  }
  const getTopViews = (stats) => {
    //return the period with the highest opens
    let totalOpens = -1;
    let topAssetId = '';

    for (const s of stats) {
      if (s.totalOpens > totalOpens) {
        totalOpens = s.totalOpens
        topAssetId = s.id
      }
    }
    return {assetId: topAssetId, totalOpens: totalOpens}

  }
  const getPrettyTimeRangeForAsset = () => {
    if (timedImagesSettings.dates == null) return;
    let result = ''

    //1 we find tthe date which has assetIdBefore as our assetId
    //three cases:
    //            1. no other dates befor the found date (<)
    //            2. found a date before the found date (between dateBefore and found date)
    //            3. we didn't find any date -> it's > than the last date
    const matchedDateIndex = timedImagesSettings.dates.findIndex(d => d.assetIdBefore === topViewsInfo.assetId)
    if (matchedDateIndex === -1) {
      const matchedDate = timedImagesSettings.dates[timedImagesSettings.dates.length -1]
      result = 'After ' + dayjs(matchedDate.date).format('DD MMM YYYY') 
    }
    else if (matchedDateIndex === 0) {
      const matchedDate = timedImagesSettings.dates[0]
      result = 'Before ' + dayjs(matchedDate.date).format('DD MMM YYYY') 
    }
    else {
      const matchedDate = timedImagesSettings.dates[matchedDateIndex]
      const previousDate = timedImagesSettings.dates[matchedDateIndex -1]
      result = 'Between ' + dayjs(previousDate.date).format('DD MMM YYYY') + ' and ' + dayjs(matchedDate.date).format('DD MMM YYYY')

    }
    if (topViewsInfo.dateRangePretty == null) {
      //we only reset topViewsInfo if the dateRangePretty wasn't set before (to avoid loops)
      const newTopViews = {...topViewsInfo, dateRangePretty: result}
      setTopViewsInfo(newTopViews)
  
    }
  }

    return <div>
            <CcTitle>Element Report Timed Images</CcTitle>
            <div className='mt-4'>
                <ReportSnippetInfo snippetInfo={snippetInfo} />
            </div>
            <div className='mt-4'>
                <ReportBar stats={[{title: 'Image Views', value: totalOpens },
                                    {title: 'Clicks', value: totalClicks},
                                    {title: 'Top views', value: topViewsInfo.totalOpens, footer: topViewsInfo.dateRangePretty},
                                    ]} />
            </div>
            <div className='mt-6 mb-2 text-xl text-ccColorDarkTeal font-semibold'>Clicks in timeline</div>
            <TimelineEditor timeline={timedImagesSettings.dates == null ? undefined : timedImagesSettings}
              reportMode
              stats={snippetTimedImagesStats}
            />

    </div>
}